import React, { useState } from 'react';
import clsx from 'clsx';
import { hexToRGB } from '../../util';
import { ChevronDownIcon } from '../../../assets/icons';
import { CirclePicker } from 'react-color';
import { defaultColors } from '../../../commons/constants';

export const CampaignColor = (props: {
  campaignColor: string;
  isDisabled: boolean;
  onValueChanged: (v: string) => void;
}) => {
  const { campaignColor, isDisabled, onValueChanged } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  return (
    <>
      <div
        className={clsx('program-edit__campaign-color-wrapper', { 'cursor-default': isDisabled })}
        style={{ border: `1px solid ${hexToRGB(campaignColor, 0.5)}` }}
        data-test={`program__campaign-color--${campaignColor}`}
        onClick={() => {
          if (isDisabled) return;
          setDisplayColorPicker((v) => !v);
        }}
        onBlur={() => {
          if (isDisabled) return;
          setDisplayColorPicker(false);
        }}
      >
        <div
          className="program__campaign-color my-auto"
          style={{ backgroundColor: hexToRGB(campaignColor, 1) }}
        />

        {!isDisabled && (
          <div className="program-edit__campaign-color--dropdown my-auto">
            <ChevronDownIcon />
          </div>
        )}
      </div>
      {displayColorPicker ? (
        <div className="program__campaign-color-selector">
          <CirclePicker
            colors={defaultColors}
            color={campaignColor}
            onChangeComplete={(color) => {
              setDisplayColorPicker(false);
              onValueChanged(color.hex.slice(1));
            }}
          />
        </div>
      ) : null}
    </>
  );
};
